// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconInfoCard: React.FC<{}> = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="430"
            height="433"
            viewBox="0 0 430 433"
        >
            <defs>
                <pattern id="c" width="100%" height="138.797%" y="-38.797%" patternUnits="objectBoundingBox">
                    <use xlinkHref="#a" transform="scale(8.91667)" />
                </pattern>
                <image
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAAAs0lEQVRoBe2YQQrDMAwE4/7J/3+AH9XS4x7FkG0Dk5vAkuIZC4zX3vt9Db5zzhosv+6u/5r8zD+udQO/tqIBDUACHiEIEKdrACOEBR5vYHSv+cK6+24zrf94A24AziBO1wBGCAtoAALE6RrACGEBDUCAOH1N7x6+C2HmWcAZSB79SAN95tlRA8mjH2mgzzw7aiB59CPfhfrMs6MzkDz6kQb6zLOjBpJHP9JAn3l21EDy6EcfG0kbmWsMNT0AAAAASUVORK5CYII="
                    id="a"
                    width="48"
                    height="48"
                />
                <path id="b" d="M0,0 L1366,0 L1366,3626 L0,3626 L0,0 Z" />
            </defs>
            <g fill="none" fillRule="evenodd" transform="translate(-16 -263)">
                <use xlinkHref="#b" fill="#FFF" />
                <g transform="translate(17 264)">
                    <path
                        fill="#FFF"
                        stroke="#B0AEAE"
                        d="M428.5,4 L428.5,427 C428.5,429.485281 426.485281,431.5 424,431.5 L4,431.5 C1.51471863,431.5 -0.5,429.485281 -0.5,427 L-0.5,4 C-0.5,1.68589194 1.25464604,-0.244648227 3.56580734,-0.478711943 L4.00000018,-0.5 L424,-0.5 C426.485281,-0.5 428.5,1.51471863 428.5,4 Z"
                    />
                    <g transform="translate(12 253)">
                        <text fill="#00214A" fontFamily="Adelle-Bold, Adelle" fontSize="14" fontWeight="bold">
                            <tspan x="0" y="162">
                                Call to Action Text
                            </tspan>
                        </text>
                        <text fill="#3B3B3B" fontFamily="Adelle-Regular, Adelle" fontSize="14">
                            <tspan x="0" y="58">
                                Lorem ipsum dolor sit amet consectetur. Dolor nec donec{" "}
                            </tspan>
                            <tspan x="0" y="80">
                                tempor sed lectus id bibendum eleifend cras. Ornare ut ac ut{" "}
                            </tspan>
                            <tspan x="0" y="102">
                                aliquet lorem integer ultrices nulla nunc. Eu commodo lacus{" "}
                            </tspan>
                            <tspan x="0" y="124">
                                orci condimentum quam.
                            </tspan>
                        </text>
                        <text fill="#0C0908" fontFamily="TVNordEF-BlackCon" fontSize="28">
                            <tspan x="0" y="25">
                                H3 (But Editable) : Title
                            </tspan>
                        </text>
                    </g>
                    <rect width="428" height="241" fill="url(#c)" />
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconInfoCard);
